module.exports = __webpack_public_path__ + "c_static/img/2-2手机天猫收藏夹.8659cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/2-2手机天猫收藏夹.jpg
// module id = jiZR
// module chunks = 33